import { IForgotPasswordBody, IForgotPasswordRequestBody, IForgotPasswordRequestResponse } from 'interfaces/forgot-password';
import { AuthorizeRequestBody, LoginRequestBody } from './requests/loginRequest';
import { baseApi } from './services/services';
import { ApiResponse } from 'interfaces/api-response';

export const authApi = baseApi.enhanceEndpoints({ addTagTypes: ['myprofile'] }).injectEndpoints({
    endpoints(builder) {
        return {
            authorize: builder.mutation({
                query: (data: AuthorizeRequestBody) => ({
                    url: '/auth/authorize',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-type': 'application/json'
                    },
                    data: {
                        code: data.code,
                        verifier: data.verifier
                    }
                }),
                invalidatesTags: ['myprofile']
            }),
            login: builder.mutation({
                query: (data: LoginRequestBody) => ({
                    url: '/auth/login',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-type': 'application/json'
                    },
                    data: { email: data.email, password: data.password, state: data.state, challenge: data.challenge }
                })
            }),
            forgotPasswordRequest: builder.mutation<ApiResponse<IForgotPasswordRequestResponse>, IForgotPasswordRequestBody>({
                query: (data) => ({
                    url: '/auth/forgot_password_request',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-type': 'application/json'
                    },
                    data: { email: data.email }
                })
            }),
            forgotPassword: builder.mutation({
                query: (data: IForgotPasswordBody) => ({
                    url: '/auth/forgot_password',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-type': 'application/json'
                    },
                    data: {
                        sessionId: data.sessionId,
                        otp: data.otp,
                        newPassword: data.newPassword
                    }
                })
            })
        };
    }
});

export const { useLoginMutation, useAuthorizeMutation, useForgotPasswordRequestMutation, useForgotPasswordMutation } = authApi;
